import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-spinner-dialog',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './loading-spinner-dialog.component.html',
  styleUrl: './loading-spinner-dialog.component.css'
})
export class LoadingSpinnerDialogComponent {

}
